export var structureLoopingGroup = function structureLoopingGroup(field, sectionFields) {
  var loopingGroupFields = sectionFields.filter(function (item) {
    return item.loopingGroup === field.loopingGroup;
  });
  var isLoopingGroupRequired = loopingGroupFields.some(function (item) {
    return item.required;
  });
  return {
    isLoopingGroupRequired: isLoopingGroupRequired,
    fields: loopingGroupFields,
    title: field.loopingGroup,
    id: field.loopingGroup.replace(/\s+/g, '-')
  };
};